import { createFileRoute } from "@tanstack/react-router";
import { ValuationDealPage } from "@/components/Valuations/DealPage";
import { useParams } from "@/lib/navigation";

function RouteComponent() {
  const params = useParams();
  return <ValuationDealPage dealId={params.id} />;
}

export const Route = createFileRoute("/_authenticated/valuations/$id/")({
  component: RouteComponent,
  staticData: { page: ["valuations", "deals"] },
});
